import { createStore } from 'vuex'

export default createStore({
  state: {
    storageData:{},
    tableConfig: {
      loading: false,
      tableData: []
    },
    publicObj: {},
    headerPhoto: '', // 头像路径
    times: '', // 时间戳
    previewImageShow: false, // 附件预览弹窗显示隐藏控制
    previewImageUrl: '', // 附件预览图片路径
    previewImageType: '' // 附件预览文件类型
  },
  getters: {
  },
  mutations: {
    setHeaderPhoto (state, param) {
      state.headerPhoto = param
    }
  },
  actions: {
  },
  modules: {
  }
})
